import { Component, Input, OnInit } from '@angular/core';
import { ExerciseContainer } from '../../agenda/agenda.component';

@Component({
  selector: 'app-agenda-block-org',
  templateUrl: './agenda-block-org.component.html',
  styleUrls: ['./agenda-block-org.component.scss']
})
export class AgendaBlockOrgComponent implements OnInit {

  @Input() container: ExerciseContainer = null;

  constructor() { }

  ngOnInit(): void {
  }

}
